import React from 'react'
import { withIcon } from '../../withIcon'

function CheckSquaredIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 4.625C5.63533 4.625 5.28559 4.76987 5.02773 5.02773C4.76987 5.28559 4.625 5.63533 4.625 6V18C4.625 18.3647 4.76987 18.7144 5.02773 18.9723C5.28559 19.2301 5.63533 19.375 6 19.375H18C18.3647 19.375 18.7144 19.2301 18.9723 18.9723C19.2301 18.7144 19.375 18.3647 19.375 18V12C19.375 11.6548 19.6548 11.375 20 11.375C20.3452 11.375 20.625 11.6548 20.625 12V18C20.625 18.6962 20.3484 19.3639 19.8562 19.8562C19.3639 20.3484 18.6962 20.625 18 20.625H6C5.30381 20.625 4.63613 20.3484 4.14384 19.8562C3.65156 19.3639 3.375 18.6962 3.375 18V6C3.375 5.30381 3.65156 4.63613 4.14384 4.14384C4.63613 3.65156 5.30381 3.375 6 3.375H15C15.3452 3.375 15.625 3.65482 15.625 4C15.625 4.34518 15.3452 4.625 15 4.625H6ZM19.5581 5.55806C19.8021 5.31398 20.1979 5.31398 20.4419 5.55806C20.686 5.80214 20.686 6.19786 20.4419 6.44194L12.4419 14.4419C12.1979 14.686 11.8021 14.686 11.5581 14.4419L8.55806 11.4419C8.31398 11.1979 8.31398 10.8021 8.55806 10.5581C8.80214 10.314 9.19786 10.314 9.44194 10.5581L12 13.1161L19.5581 5.55806Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CheckSquaredIcon)
